@if (loading()) {
  <div class="rcpt-skeleton">
    <p-skeleton height="2rem" width="60%" />
    <p-skeleton height="1rem" width="40%" />
    <p-skeleton height="8rem" />
    <p-skeleton height="6rem" />
  </div>
} @else if (notFound() || !receipt()) {
  <div class="rcpt-empty">
    <i class="pi pi-file-excel"></i>
    <p>No receipt found for that reference.</p>
  </div>
} @else if (receipt(); as r) {
  <div class="receipt">
    <!-- ===== header ===== -->
    <div class="rc-head">
      <div class="rc-brand">
        @if (r.issuer?.logoUrl && !logoFailed()) {
          <img class="rc-logo" [src]="r.issuer!.logoUrl" [alt]="issuerName()"
            (error)="logoFailed.set(true)" />
        } @else {
          <h3>{{ issuerName() }}</h3>
        }
        <small>Health Insurance Receipt</small>
      </div>
      <div class="rc-meta">
        <span class="rc-title">PAYMENT RECEIPT</span>
        <p-tag [value]="r.paymentStatus || '—'" [severity]="statusSeverity(r.paymentStatus)" />
        <div class="rc-kv"><span>Receipt No</span><strong class="mono">{{ r.receiptNo }}</strong></div>
        <div class="rc-kv"><span>Date</span><strong>{{ istDate(r.paidAt || r.createdDate, true) }} IST</strong></div>
      </div>
    </div>

    <!-- ===== parties ===== -->
    <div class="rc-parties">
      <div class="rc-party">
        <span class="rc-label">Billed To</span>
        <strong>{{ r.memberName || ('Member #' + r.memberId) }}</strong>
        @if (r.memberUniqueId) { <small class="mono">{{ r.memberUniqueId }}</small> }
        @if (r.memberEmail) { <small>{{ r.memberEmail }}</small> }
        @if (r.memberMobile) { <small>{{ r.memberMobile }}</small> }
        @if (addressLine()) { <small>{{ addressLine() }}</small> }
      </div>
      <div class="rc-party">
        <span class="rc-label">Issued By</span>
        <strong>{{ issuerName() }}</strong>
        @if (r.issuer?.address) { <small>{{ r.issuer!.address }}</small> }
        @if (r.issuer?.phone) { <small>Phone: {{ r.issuer!.phone }}</small> }
        @if (r.issuer?.email) { <small>Email: {{ r.issuer!.email }}</small> }
        @if (r.issuer?.gstin) { <small>GSTIN: {{ r.issuer!.gstin }}</small> }
        @if (r.partnerName) {
          <small>Channel: {{ r.partnerName }}@if (r.partnerCode) { ({{ r.partnerCode }})}</small>
        }
        @if (r.gatewayName) { <small>Gateway: {{ r.gatewayName }}</small> }
      </div>
    </div>

    <!-- ===== line items (mirrors the server receipt: policy premium, doctor add-on split out, GST, muted sum insured) ===== -->
    <div class="rc-items">
      <div class="rc-row rc-row-head">
        <span>Description</span>
        <span class="ta-r">Amount</span>
      </div>
      @if (view(); as v) {
        @for (it of v.items; track $index) {
          <div class="rc-row" [class.rc-muted]="it.muted">
            <span>{{ it.label }}</span>
            <span class="ta-r">{{ sym() }}{{ it.amount | number: '1.0-0' }}</span>
          </div>
        }
        <div class="rc-row rc-total">
          <span>Total Paid</span>
          <span class="ta-r">{{ sym() }}{{ v.total | number: '1.0-0' }} <small>{{ r.currency || 'INR' }}</small></span>
        </div>
      }
    </div>

    <!-- ===== payment details ===== -->
    <div class="rc-payment">
      <span class="rc-label">Payment Details</span>
      <div class="rc-pgrid">
        <div><span>Mode</span><strong>{{ r.paymentMode || '—' }}</strong></div>
        <div><span>Gateway</span><strong>{{ r.gatewayName || '—' }}</strong></div>
        <div><span>Order Id</span><strong class="mono">{{ r.gatewayOrderId || '—' }}</strong></div>
        <div><span>Txn Id</span><strong class="mono">{{ r.gatewayPaymentId || '—' }}</strong></div>
        <div class="span-all"><span>Paid At</span><strong>{{ r.paidAt ? istDate(r.paidAt, true) + ' IST' : '—' }}</strong></div>
      </div>
    </div>

    <!-- ===== actions ===== -->
    <div class="rc-actions">
      @if (!isSuccess()) {
        <small class="rc-note"><i class="pi pi-info-circle"></i> A receipt is available only after the payment succeeds.</small>
      }
      <p-button label="Print" icon="pi pi-print" [outlined]="true"
        [disabled]="!isSuccess()" [loading]="printing()" (onClick)="print()" />
      <p-button label="Download PDF" icon="pi pi-download"
        [disabled]="!isSuccess()" [loading]="downloading()" (onClick)="download()" />
    </div>
  </div>
}
